// Mirrors legacy CommentTable's `removeEncode` — strips markup from the
// stored review HTML for plain-text display (table cell + dialog textarea).
export function stripHtml(html: string): string {
  if (!html) return ''
  if (typeof DOMParser === 'undefined') {
    return html.replace(/(<([^>]+)>)/gi, '')
  }
  const doc = new DOMParser().parseFromString(html, 'text/html')
  return doc.body.textContent || ''
}
